module.exports = __webpack_public_path__ + "cd2b972902917f45dbf8ce5f01dc32b3.png";